import Navbar from './components/Navbar';
import ScrollProgress from './components/ScrollProgress';
import Section1Carousel from './components/Section1Carousel';
import Section2Carousel from './components/Section2Carousel';
import Section3Carousel from './components/Section3Carousel';
import Section5Carousel from './components/Section5Carousel';
import Section6Summary from './components/Section6Summary';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen page-glow animate-gradient-flow">
      {/* 全局浮动光斑 */}
      <div className="fixed top-[15%] left-[5%] w-80 h-80 rounded-full bg-primary-100/5 blur-[110px] pointer-events-none animate-orb-float-1 z-0" />
      <div className="fixed bottom-[20%] right-[8%] w-72 h-72 rounded-full bg-accent-100/4 blur-[100px] pointer-events-none animate-orb-float-2 z-0" />
      <div className="fixed top-[55%] left-[45%] w-64 h-64 rounded-full bg-secondary-100/3 blur-[95px] pointer-events-none animate-orb-float-3 z-0" />

      <ScrollProgress />
      <Navbar />
      <main className="relative z-[1]">
        <Section1Carousel />

        <Section2Carousel />

        <Section3Carousel />

        <Section5Carousel />

        <Section6Summary />
      </main>
      <Footer />
    </div>
  );
}